module.exports = __webpack_public_path__ + "img/Icon - Warning.05692bc4.svg";